import { MAX_STUDENTS_IN_CLASS } from './business-rule-constants';

export namespace TooltipHelpers {

  export const ONE_ROSTER_TOOLTIP = 'This feature is controlled by your institution.';

  export const MAX_STUDENTS_TOOLTIP = `You cannot add more than ${MAX_STUDENTS_IN_CLASS} students to a classroom.`;

  export function getTooltipHandlingOneRoster(tooltip: string, isOneRoster: boolean): string {
    return isOneRoster
      ? ONE_ROSTER_TOOLTIP
      : tooltip;
  }

}
